const duration = {
  long: '500ms',
  medium: '300ms',
  short: '100ms',
};

export default duration;
